import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumberLettersOnlyDirective } from './directives/numberlettersonly.directive';
import { CanDeactivateGuard } from './can-deactivate.guard';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { RouterModule } from '@angular/router';
import { SharedSingleSelectionPipe } from '../shared/single-selection.pipe';
import { TablefilterPipe } from './pipes/tablefilter.pipe';
import { TablefilterMultiplePipe } from './pipes/tablefilter-multiple.pipe';
import { SanitizeHtmlPipe } from './sanitize-html.pipe';
import { SanitizeUrlPipe } from './sanitize-url.pipe';
import { SortByFilterPipe } from './sortByalphabetic.pipe';
import { IntegerOnlyDirective } from './directives/integeronly.directive';
import { IframeTrackerDirective } from './directives/iframetracker.directive';
import { UniqueFilterPipe} from './pipes/uniquefilter.pipe'
import { VerticalBannerComponent} from './advertising/vertical-banner'
import { HorizontalBannerComponent} from './advertising/horizontal-banner'
import { OwlModule } from 'ngx-owl-carousel';
import { LoadingScreenComponent } from './loading-screen/loading-screen.component';
import { LoadingIconComponent } from './loading-icon/loading-icon.component';
import { ToastComponent } from './toast/toast.component';
import { PostCodeDirective } from './directives/postcode.directive';
import { SuburbDirective } from './directives/suburb.directive';
import { NgModelChangeDebouncedDirective } from './directives/debounce.directive';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { NgbCarouselModule, NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CspTransitionSkuPipe } from './pipes/sku-pipe';
import { DisableControlDirective } from './directives/disable-control.directive';
import { RefreshButtonComponent } from './refresh-button/refresh-button.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    OwlModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    NgSelectModule,
    NgbPopoverModule,
    NgbTooltipModule,
    NgbCarouselModule
  ],
  declarations: [
    // BreadcrumbComponent,
    SharedSingleSelectionPipe,
    TablefilterPipe,
    TablefilterMultiplePipe,
    SortByFilterPipe,
    IntegerOnlyDirective,
    NumberLettersOnlyDirective,
    SanitizeHtmlPipe,
    SanitizeUrlPipe,
    UniqueFilterPipe,
    VerticalBannerComponent,
    HorizontalBannerComponent,
    LoadingScreenComponent,
    LoadingIconComponent,
    ToastComponent,
    RefreshButtonComponent,
    IframeTrackerDirective,
    // PasswordComponent,
    PostCodeDirective,
    SuburbDirective,
    NgModelChangeDebouncedDirective,
    DisableControlDirective,
    CspTransitionSkuPipe
  ],
  exports: [
    // BreadcrumbComponent,
    TablefilterPipe,
    TablefilterMultiplePipe,
    SharedSingleSelectionPipe,
    SortByFilterPipe,
    IntegerOnlyDirective,
    NumberLettersOnlyDirective,
    SanitizeHtmlPipe,
    SanitizeUrlPipe,
    UniqueFilterPipe,
    VerticalBannerComponent,
    HorizontalBannerComponent,
    LoadingScreenComponent,
    LoadingIconComponent,
    RefreshButtonComponent,
    IframeTrackerDirective,
    // PasswordComponent,
    PostCodeDirective,
    SuburbDirective,
    NgModelChangeDebouncedDirective,
    DisableControlDirective,
    CspTransitionSkuPipe
  ]
})
export class SharedModule { }
